import DepositoCrud from './DepositoCrud.vue'
export default DepositoCrud
